import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import { useMediaQuery, useTheme } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Modal from "@mui/material/Modal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLeft from "./AuthLeft";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: '2px solid #000',
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const Otp = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  //   const path = usercalls();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isOpen, setIsOpen] = useState(false);
  const toggleVisibility = () => {
    setIsOpen((prev) => !prev);
  };

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [otp, setOtp] = useState(Array(6).fill("")); // Array with 6 empty strings
  const inputRefs = useRef([]); // Array of refs for each input field

  const handleKeyDown = (e) => {
    if (
      !/^[0-9]{1}$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      !e.metaKey
    ) {
      e.preventDefault();
    }

    if (e.key === "Delete" || e.key === "Backspace") {
      const index = inputRefs.current.indexOf(e.target);
      if (index > 0) {
        setOtp((prevOtp) => [
          ...prevOtp.slice(0, index - 1),
          "",
          ...prevOtp.slice(index),
        ]);
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleInput = (e) => {
    const { target } = e;
    const index = inputRefs.current.indexOf(target);
    if (target.value) {
      setOtp((prevOtp) => [
        ...prevOtp.slice(0, index),
        target.value,
        ...prevOtp.slice(index + 1),
      ]);
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text");
    if (!new RegExp(`^[0-9]{${otp.length}}$`).test(text)) {
      return;
    }
    const digits = text.split("");
    setOtp(digits);
  };
  const [voices, setVoices] = useState([]);
  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
      <ToastContainer />
      <div className="register">
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "flex-start", pt: 0 }}
          className={!md ? "medium" : ""}
        >
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <AuthLeft />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: "600px",
                margin: "0 auto",
                height: "100vh",
              }}
            >
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Box
                  sx={{
                    my: md && 3,
                    marginRight: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // padding: "28px 25px",
                  }}
                  //   className={!md && "log-bcg"}
                >
                  <h2 className="c-accout">OTP Verification</h2>

                  {/* <p>We will send you a verification to your mail</p> */}

                  <Box sx={{ mt: 4, width: "100%" }}>
                    <Grid container spacing={2}>
                      {voices.length < 1 ? (
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                          <div className="input-common otp-input mt-20 mb-20">
                            {/* <label>Email</label> */}
                            <form id="otp-form" className="otp-input-form">
                              {otp.map((digit, index) => (
                                <input
                                  key={index}
                                  type="text"
                                  maxLength={1}
                                  value={digit}
                                  onChange={handleInput}
                                  onKeyDown={handleKeyDown}
                                  onFocus={handleFocus}
                                  onPaste={handlePaste}
                                  ref={(el) => (inputRefs.current[index] = el)}
                                  className="shadow-xs flex w-[64px] items-center justify-center rounded-lg border border-stroke bg-white p-2 text-center text-2xl font-medium text-gray-5 outline-none sm:text-4xl dark:border-dark-3 dark:bg-white/5"
                                />
                              ))}
                              {/* You can conditionally render a submit button here based on otp length */}
                            </form>
                          </div>
                        </Grid>
                      ) : (
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                          <Box sx={{ width: "100%" }}>
                            <div className="input-common mt-20">
                              <label>Email:</label>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                placeholder="Enter Your Email"
                              />
                            </div>

                            <div className="input-common mt-20">
                              <label>Password</label>
                              <FormControl
                                sx={{ mt: 1, width: "100%" }}
                                variant="outlined"
                              >
                                <OutlinedInput
                                  id="outlined-adornment-password"
                                  type={showPassword ? "text" : "password"}
                                  value={password}
                                  placeholder="********"
                                  onChange={(e) => {
                                    setPassword(e.target.value);
                                  }}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        className="eye-icon"
                                        aria-label={
                                          showPassword
                                            ? "hide the password"
                                            : "display the password"
                                        }
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                            </div>
                          </Box>
                        </Grid>
                      )}
                    </Grid>

                    <div className="common-btn text-center">
                      {load ? (
                        <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          // onClick={() => {
                          //   navigate("/trade");
                          // }}
                        >
                          Verify
                        </Button>
                      )}
                    </div>

                    <div className="text-center alraedy mt-30">
                      <Link to="/login" variant="body2">
                        {"Already have an account? "}
                        <span>Login</span>
                      </Link>
                    </div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default Otp;
